import { AddShelfDTO, DeleteShelfDTO, GetShelfDTO, UpdateShelfDTO, } from "../../dtos/shelfNumberDTO";
import axios from "../../utils/axiosConfig";

export const add_shelf_system = async (shelf: AddShelfDTO) => { 
    const url= '/api/shelf/add';
    const {data} = await axios.post(url, shelf);
    return data;
}

export const get_shelf_system = async (params: GetShelfDTO) => {
    try {
      const query = new URLSearchParams();
      query.append("pharmacy_id", String(params.pharmacy_id));
      query.append("page", String(params.page));
      query.append("limit", String(params.limit));
      query.append("search", params.search); // If it's an empty string, still valid
  
      const url = `/api/shelf/get?${query.toString()}`;
      const { data } = await axios.get(url);
      return data;
    } catch (error: any) {
      console.error("Error in get_shelf_system:", error);
      throw error;
    }
  };
  
  export const delete_shelf_system = async (dto: DeleteShelfDTO) => {
  
    const { data } = await axios.delete(
      `/api/shelf/delete?pharmacy_id=${dto.pharmacy_id}&shelf_id=${dto.shelf_id}`
    );
    return data;
  };
  
export const update_shelf_system = async (shelf_update: UpdateShelfDTO) => {
    const url = '/api/shelf/update';
    const { data } = await axios.put(url, shelf_update);
    return data;
};

